import React, { useRef } from "react";
import { Modal, Tooltip } from "antd";
import style from "./index.module.scss";
import Statistic from "../Statistics";
import Operate from "../Operate";
import {
    exportSignInStu,
    removeSignIn,
    SignInListItem,
    SignStatus as SignStatusType
} from "service/signIn";
import moment from "moment";
import useRequest from "utils/useRequest";
import ResultMessage from "components/CourseComponents/ResultMessage";
import classNames from "classnames";
import SignStatus from "./components/SignStatus";
import { renderValidityTime } from "utils/common";
import { SignType } from "../../../../service/signIn";

interface ListItemProps {
    weekTimeId: number;
    basename: string;
    data: SignInListItem;
    onDelSuccess: () => void;
    onEdit: () => void;
    onEnd?: () => void;
    gotoDetail: (signInId: number, params?: StringMap) => void;
    mode?: "projection" | "normal"; // 投屏还是非投屏
}

export default function ListItem({
    weekTimeId,
    basename,
    data,
    onDelSuccess,
    onEdit,
    onEnd,
    gotoDetail,
    mode = "normal"
}: ListItemProps) {
    const ref = useRef<HTMLDivElement>(null);

    const [, , remove] = useRequest(() => removeSignIn(data.id, weekTimeId), {
        autoStart: false
    });

    function handleDelete() {
        Modal.confirm({
            getContainer,
            title: `删除“${data.title}”？`,
            content:
                "签到活动删除后，该活动中的所有签到数据都将被删除且不可恢复，确定要删除吗？",
            onOk: () =>
                remove().then(() => {
                    onDelSuccess();
                    ResultMessage.success("删除成功！");
                })
        });
    }

    function getContainer(): any {
        return document.querySelector(".PopupContainer");
    }

    return (
        <div
            ref={ref}
            className={classNames(style.root, {
                [style.digitalRoot]: data.type === SignType.Number,
                [style.normalRoot]: data.type === SignType.Normal,
                [style.liveRoot]: data.type === SignType.Live
            })}>
            <h1 className={style.title}>
                <Tooltip title={data.title}>{data.title}</Tooltip>

                <SignStatus state={data.status} />
            </h1>

            {data.type !== SignType.Live && (
                <div className={style.info}>
                    {data.type === SignType.Number && (
                        <span>
                            数字码有效时长 {data.refreshTime}
                            秒&nbsp;&nbsp;|&nbsp;&nbsp;{" "}
                        </span>
                    )}

                    <span>
                        活动时长 {renderValidityTime(data.validityTime)}
                    </span>

                    {data.status !== SignStatusType.Idle && (
                        <span>
                            &nbsp;&nbsp;|&nbsp;&nbsp; 开始时间
                            {moment(data.startTime).format("MM-DD HH:mm")}
                        </span>
                    )}
                    {data.status === SignStatusType.Done && (
                        <span>
                            &nbsp;&nbsp;|&nbsp;&nbsp; 结束时间
                            {moment(data.endTime).format("MM-DD HH:mm")}
                        </span>
                    )}
                </div>
            )}

            <div className={style.tools}>
                {data.status === SignStatusType.Done && (
                    <Statistic
                        signId={data.id}
                        className={style.statistics}
                        refObj={ref}
                        courseStuCount={data.courseStuCount}
                        signInStuCount={data.signInStuCount}
                        notSingInStuCount={data.notSingInStuCount}
                        onDelete={handleDelete}
                        onExport={() => exportSignInStu(data.id, data.type)}
                        gotoDetail={gotoDetail}
                    />
                )}

                {data.status !== SignStatusType.Done && (
                    <Operate
                        state={data.status}
                        signType={data.type}
                        className={style.operate}
                        refObj={ref}
                        signId={data.id}
                        onDelete={handleDelete}
                        onSetting={onEdit}
                        gotoDetail={gotoDetail}
                        onEnd={onEnd}
                        mode={mode}
                    />
                )}
            </div>
        </div>
    );
}
